import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    --background: white;
    --modal-background-color: white;
    --red: #e52e40;
    --blue: #5429cc;
    --green: #10105c;
    --blue-light: #6933ff;
    --text-body: #eeeeee;
    --text-title: #363f5f;
    --shape: #ffffff;
    --primaryColor: #c7cad9;
    --title-color: #f5f5f5;
    --secondaryColor: #0000a0;
    --card-background-color: #272727;
    --prices-background: #1b1e29;
    --price-up: #0fc679;
    --price-up-background: rgba(15,198,121,.3);
    --price-down: #ff5252;
    --price-down-background: rgba(255,82,82,.1);;
  }
  *{
    margin:0;
    padding:0;
    box-sizing: border-box;
  }

  html { 
      @media (max-width: 1080px) {
        font-size: 93,75%;
      }
      @media (max-width: 720px){
        font-size: 87.5%;
      }
  }

  body{ 
    color: #eee;
    margin: 0;
    font-size: 0.875rem;
    font-family: "Comic Sans MS", sans-serif;
    font-weight: 500;
    line-height: 1.43;
    background-color: var(--modal-background-color);
    -webkit-font-smoothing: antialiased;
  }

  body, input, textarea, button {
    font-family: "Comic Sans MS", sans-serif;
    font-weight: 500;
  }

  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 600;
  }

  p{
    margin: 0;
  }
  button { 
    cursor: pointer;
  }

  .item-bounce {
	  -webkit-animation: bounce 8s infinite ease-in-out;
	  animation: bounce 8s infinite ease-in-out;
  }

  .btn_one {
    background:var(--secondaryColor);
    text-decoration: none;
    border-radius: 30px;
    border:2px solid var(--secondaryColor);
    color: #fff;
    font-weight: 700;
    padding: 14px 40px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    text-transform: uppercase;
    z-index: 1;
    overflow: hidden;
    display: inline-block;
    -webkit-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s;
    font-size: 14px;
  }
  .btn_one i{margin-right:5px;}
  .btn_one:hover{
    background:none;
    border:2px solid var(--secondaryColor);
    color:var(--secondaryColor);
  }
  .btn_two {
    background:none;
    text-decoration: none;
    border-radius: 30px;
    border:2px solid #fff;
    color: #fff;
    font-weight: 700;
    padding: 14px 40px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    text-transform: uppercase;
    z-index: 1;
    overflow: hidden;
    display: inline-block;
    -webkit-transition: all 0.3s ease 0s;
    transition: all 0.3s ease 0s;
    font-size: 14px;
  }
  .btn_two i{margin-right:5px;}
  .btn_two:hover{
  background:var(--secondaryColor);
  border:2px solid var(--secondaryColor);
  color:#fff;
  }

  [disabled] {
    opacity: 0.6;
    cursor: not-allowed;
  }






  //New global class
  .dc-section{
    padding: 50px 0 0 0;
    position: relative;
    z-index: 1;
  }
  .dc-background-img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .dc-title{
    color: rgb(0, 0, 0);
    font-family: DynaPuff;
    font-style: normal;
    font-size: 41px;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -4.23px;
    text-align: center;
    text-transform: uppercase;
    margin: 35px auto 0px;
    transition: all 0.25s ease 0s;
    &--white{
      color: rgb(255, 255, 255);
    }
  }
  .dc-text{
    transition: all 0.25s ease 0s;
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: -0.19px;
    max-width: 493px;
    text-align: center;
    opacity: 0.9;
    margin: 10px auto 0px;
  }
  .slick-arrow{
    filter: invert(100);
  }
  .dc-invert{
    filter: invert(100);
    &::selection{
      background: orange !important;
    }
  }
  @media screen and (min-width: 700px){
    .dc-title{
      font-size: 71px;
    }
  }
  @media screen and (min-width: 1000px){
    .dc-title{
      margin-top: 62px;
      font-size: 141px;
      text-align: left;
      margin-left: 0px;
    }
    .dc-text {
      text-align: left;
      margin-left: 0px;
      margin-top: 7px;
      font-size: 19px;
    }
    .dc-title-right{
margin-top: 62px;
      font-size: 141px;
      text-align: right;
      margin-right: 0px;
    }
    .dc-text-right{
text-align: right;
      margin-right: 0px;
      margin-top: 7px;
      font-size: 19px;
    }
  }
`;
